import RightPanel from "../panel/RightPanel";
import LeftPanel from "../panel/LeftPanel";
import Map from "./../map/Map";
import MainPanel from "./../panel/MainPanel";
import NavBar from "./../navbar/NavBar";

const MapPage = () => {
  return (
    <>
      <NavBar small />
      <div className="map">
        <RightPanel />
        <Map />
        <MainPanel />
        {/* <LeftPanel /> */}
      </div>
    </>
  );
};

export default MapPage;
